import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var TaskManager = /*#__PURE__*/function () {
  function TaskManager() {
    _classCallCheck(this, TaskManager);
    _defineProperty(this, "runningTask", null);
    _defineProperty(this, "taskList", []);
  }
  _createClass(TaskManager, [{
    key: "addTask",
    value: function addTask(task) {
      this.taskList.push(task);
      void this.runTask();
    }
  }, {
    key: "runTask",
    value: function () {
      var _runTask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.taskList.length === 0 || this.runningTask)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              // 这里的叹号是因为上面已经判断不为空了，有人能优化这个叹号更好！
              this.runningTask = this.taskList.pop();
              _context.next = 5;
              return this.runningTask.run();
            case 5:
              this.runningTask = null;
              void this.runTask();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function runTask() {
        return _runTask.apply(this, arguments);
      }
      return runTask;
    }()
  }]);
  return TaskManager;
}();
//# sourceMappingURL=drive-data-api-task-manager.js.map